import * as FlatModels from '@medsurf/flat-models';
import * as EntityBaseActions from '../base/entity.base.actions';

// <editor-fold desc="Action Types">

/**
 * Action Types
 */
export enum ActionTypes {
  /**
   * Store
   */
  GetEntitySuccess = '[STORE | ENTITY | MEDIA] Get Entity Success',
  GetEntitiesSuccess = '[STORE | ENTITY | MEDIA] Get Entities Success',
  ModifyEntitySuccess = '[STORE | ENTITY | MEDIA] Modify Entity Success',
  ModifyEntitiesSuccess = '[STORE | ENTITY | MEDIA] Modify Entities Success',
  AddEntity = '[STORE | ENTITY | MEDIA] Add Entity',
  UpdateEntity = '[STORE | ENTITY | MEDIA] Update Entity',
  RemoveEntity = '[STORE | ENTITY | MEDIA] Remove Entity',
  RearrangeMediaCopyrights = '[STORE | ENTITY | MEDIA] Rearrange Media Copyrights',
  /**
   * Request
   */
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">

/**
 * Get Entity Success
 */
export class GetEntitySuccess extends EntityBaseActions.GetEntitySuccess {
  public static readonly type = ActionTypes.GetEntitySuccess;
}

/**
 * Get Entities Success
 */
export class GetEntitiesSuccess extends EntityBaseActions.GetEntitiesSuccess {
  public static readonly type = ActionTypes.GetEntitiesSuccess;
}

/**
 * Modify Entity Success
 */
export class ModifyEntitySuccess extends EntityBaseActions.ModifyEntitySuccess {
  public static readonly type = ActionTypes.ModifyEntitySuccess;
}

/**
 * Modify Entities Success
 */
export class ModifyEntitiesSuccess extends EntityBaseActions.ModifyEntitiesSuccess {
  public static readonly type = ActionTypes.ModifyEntitiesSuccess;
}

/**
 * Add Entity
 */
export class AddEntity extends EntityBaseActions.AddEntity<FlatModels.MediaEntityModels.MediaEntityType> {
  public static readonly type = ActionTypes.AddEntity;
}

/**
 * Update Entity
 */
export class UpdateEntity extends EntityBaseActions.UpdateEntity<FlatModels.MediaEntityModels.MediaEntityType> {
  public static readonly type = ActionTypes.UpdateEntity;
}

/**
 * Remove Entity
 */
export class RemoveEntity extends EntityBaseActions.RemoveEntity<FlatModels.MediaEntityModels.MediaEntityType> {
  public static readonly type = ActionTypes.RemoveEntity;
}

/**
 * Rearrange Rearrange Media Copyrights
 */
export class RearrangeMediaCopyrights {
  public static readonly type = ActionTypes.RearrangeMediaCopyrights;
  
  public constructor(public media: FlatModels.MediaEntityModels.MediaEntityType,
                     public mediaCopyrights: FlatModels.MediaEntityModels.MediaCopyright[]) {
  }
}

// </editor-fold>

// <editor-fold desc="Request">

// </editor-fold>